// extracted by mini-css-extract-plugin
export default {"container":"aC-z","dimension":"bC-z","dimensionLabels":"cC-z"};